export default __webpack_public_path__ + "static/media/name.b75e4d4e.svg";